import { getRegisterFunction } from '../../utils/register.js';
import { OneUxBusyElement } from './OneUxBusyElement.js';
export const register = getRegisterFunction(OneUxBusyElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-busy': OneUxBusyElement;
    "busy-fe5c5c0fd90f4c7dd6ecddf20a47f897": OneUxBusyElement;
  }
}